<form [formGroup]="form" class="app-install-trigger-form beacon-region-entry-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section class="section">
    <header class="section-header">
      <h4>Beacon Region</h4>
      <span class="hint">From selected flow</span>
    </header>

    <p class="hint">
      This test enters the beacon region configured on the selected flow's
      trigger. BeaconRegionEntry flows require that configured object, so there
      is no separate beacon-region selector here.
    </p>
  </section>
</form>
